import { render, staticRenderFns } from "./product.information.page.vue?vue&type=template&id=70f3fc19&scoped=true&"
import script from "./product.information.page.vue?vue&type=script&lang=js&"
export * from "./product.information.page.vue?vue&type=script&lang=js&"
import style0 from "./product.information.page.vue?vue&type=style&index=0&id=70f3fc19&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f3fc19",
  null
  
)

export default component.exports